import {ErrorPage} from '@src/enums/api';
import {ServiceMaintenance} from '@src/types/error';
import {isAndroid, isIOS, objToSearch} from '@src/utils/common';
import Router from 'next/router';
import {executeScheme} from './scheme';

export const goToErrorPage = (errorPathname: ErrorPage) => {
  const {pathname, search} = window.location;
  const next = `${pathname}${search}`;
  if (pathname === errorPathname) {
    return;
  }
  Router.replace(`${errorPathname}?next=${encodeURIComponent(next)}`);
};

export const goToServiceMaintenancePage = (serviceMaintenance: ServiceMaintenance) => {
  const {start = '', end = ''} = serviceMaintenance;

  Router.replace(`${ErrorPage.SERVICE_MAINTENANCE}?start=${start}&end=${end}`);
};

export const redirectUrl = (url = '', as = '') => {
  const isExternalUrl = new RegExp('^http').test(url);
  if (!isExternalUrl) {
    Router.push(url, as);
  } else {
    window.location.href = url;
  }
};

export enum KakaoAccountType {
  LOGIN = 'login',
  LOGOUT = 'logout',
}

export const redirectKakaoAccount = (type: KakaoAccountType = KakaoAccountType.LOGIN, url = window.location.href) => {
  const continuePath = `${window.location.origin}${url.replace(window.location.origin, '')}`;
  const params = {continue: continuePath};
  redirectUrl(`${process.env.NEXT_PUBLIC_ACCOUNTS_URL}/${type}${objToSearch(params)}`);
};

export const openCounselingTalk = () => {
  // [SUBSCOPER-2266] 안드로이드에서 상담톡 작동하지 않는 이슈로 인해 스킴 교체
  // const BIZ_MESSAGE_URL = process.env.NEXT_PUBLIC_BIZ_MESSAGE_URL || '';

  let BIZ_MESSAGE_URL = process.env.NEXT_PUBLIC_BIZ_MESSAGE_URL || '';
  if (isIOS()) {
    BIZ_MESSAGE_URL = process.env.NEXT_PUBLIC_IOS_BIZ_COUNSELING_URL || '';
  } else if (isAndroid()) {
    BIZ_MESSAGE_URL = process.env.NEXT_PUBLIC_ANDROID_BIZ_COUNSELING_URL || '';
  }

  executeScheme(BIZ_MESSAGE_URL);
};

export const matchPathname = (regexps: (string | RegExp)[], pathname: string) => regexps.some(regex => {
  const isMatch = regex instanceof RegExp ? regex.test(pathname) : regex === pathname;
  return isMatch;
});

export const validateNext = (next: string): boolean => {
  // https://sandbox-on.devel.kakao.com, https://on.kakao.com
  // 위 링크들을 제외한 외부링크 필터링
  const isExternalUrl = new RegExp('^http').test(next);
  if (!isExternalUrl) {
    return true;
  }
  /*
  // 허용 케이스
  const NORMAL_REDIRECT_URL = [
    'https://john.fedev.kakao.com/', // 현재 경로
    'http://john.fedev.kakao.com/', // http 요청
    'http://john.fedev.kakao.com/path', // 도메인 이후에 path 존재
    'https://john.fedev.kakao.com/?continue=https://mystore.kakao.com/main&isCanceled=true', // 쿼리가 존재하는 경우
    'HttpS://John.Fedev.Kakao.CEom/', // 대소문자 변경
  ];

  // 허용하지 않는 케이스
  const ABNORMAL_REDIRECT_URL = [
    'http://john.fedev.kakao.com\@google.com',
    'http://john.fedev.kakao.com\\\@google.com',
    'http://john.fedev.kakao.com.google.com',
    'https://john.fedev.kakao.com', // 트레일링 슬래시 없음
    'ttt://john.fedev.kakao.com/path/', // http, https로 시작하지 않음
    'https://google.com/search/john.fedev.kakao.com/', // 카카오 도메인 이전에 슬래시 포함됨
    'https://google.com\\john.fedev.kakao.com/', // 카카오 도메인 이전에 역슬래시 포함됨
    'https://google.com?john.fedev.kakao.com/', // 카카오 도메인 이전에 물음표 포함됨
    'https://google.com#john.fedev.kakao.com/', // 카카오 도메인 이전에 샵 포함됨
  ];
  */
  const isSubscribeOnUrl = new RegExp(`^(https?://)${location.hostname}/`, 'i').test(next);
  return isSubscribeOnUrl;
};

// '/'로 시작하지 않는 경로는 전부 '/' 경로로 반환
export const getValidPath = (path: string | string[] | undefined): string => {
  if (!path) {
    return '/';
  }

  if (typeof path === 'string') {
    return /^\//.test(path) ? path : '/';
  } else {
    const pathString = path.join('');
    return /^\//.test(pathString) ? pathString : '/';
  }
};
